// extracted by mini-css-extract-plugin
export default {"app_launcher":"AppLauncher_app_launcher__sLMlE","img":"AppLauncher_img__t8n0u"};